var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawnArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 86,
    viewBox: "0 0 62 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83406 5.94747C0.469829 4.15264 -0.335273 2.88906 0.122935 1.69551C1.06742 -0.75863 8.18416 -0.506512 13.7428 2.17873C19.9161 5.16111 31.9909 16.8375 37.5886 25.2404C42.8745 33.1741 45.8765 50.2257 46.8581 56.3525C47.2281 58.6596 47.6392 60.5464 47.7715 60.5464C47.9049 60.5464 49.8373 53.8914 54.2165 49.5216C60.2484 43.5029 62 43.5759 62 49.8468C62 54.9652 56.9998 73.0935 53.9227 79.1323C50.2049 86.4287 43.2064 88.0725 36.2361 83.2873C15.1164 68.7866 11.6864 65.7502 13.3658 63.0369C14.6252 61.004 22.8669 61.9934 29.4382 64.9668L35.9353 67.9062L35.3668 63.7162C33.9521 53.2784 31.6339 43.4298 29.4151 38.4225C24.3708 27.0402 14.1278 14.5274 2.83406 5.94747Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawnArrow);
export default __webpack_public_path__ + "static/media/drawnArrow.aa2fa515b00ca65585236d1f9b50d121.svg";
export { ForwardRef as ReactComponent };